__webpack_require__.p = "/portal/web_tarot/samael/";